import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { GlobalService } from '@/Servicios';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-pagina-mantenimiento',
  templateUrl: './pagina-mantenimiento.component.html',
  styleUrls: ['./pagina-mantenimiento.component.scss']
})
export class PaginaMantenimientoComponent implements OnInit {
  @Output() actNombreModulo: EventEmitter<string[]> = new EventEmitter();
  @Output() ruta: EventEmitter<string> = new EventEmitter();

  public IdUsuario:number;
  public IdPadre:number = 0;
  public IsPAC:boolean
  public JWT:string;

  constructor(private global:GlobalService,
              private activatedRoute: ActivatedRoute, 
              private SpinnerService: NgxSpinnerService,
              private router: Router) { 
    
      this.global.toolbar = true;
      this.SpinnerService.hide();
    
  }

  ngOnInit() {
  }

}
